const EQUIPMENT_DEVICE_TYPES = new Set([
  'treadmill',
  'stationary_bike',
  'bike',
  'elliptical',
  'rowing_machine',
  'smart_trainer',
]);

const normalize = (value) => String(value || '').trim().toLowerCase();

export const isEquipmentPrescription = (prescription = {}) => {
  const targetDevice = normalize(prescription.target_device_type);
  const workoutType = normalize(prescription.workout_type);
  return EQUIPMENT_DEVICE_TYPES.has(targetDevice) || ['endurance', 'recovery', 'interval'].includes(workoutType);
};

export const findBlockedEquipmentDelivery = (prescription = {}, deliveries = []) => {
  if (!prescription?.id || !Array.isArray(deliveries)) return null;
  return deliveries.find((delivery) => {
    if (delivery?.workout_prescription_id !== prescription.id) return false;
    const status = normalize(delivery.status);
    const mode = normalize(delivery.delivery_mode);
    return status === 'blocked_no_verified_capability' || mode === 'phone_guided' || mode === 'read_only';
  }) || null;
};

export const findPhoneGuidedWorkout = (prescription = {}, phoneGuidedWorkouts = [], delivery = null) => {
  if (!prescription?.id || !Array.isArray(phoneGuidedWorkouts)) return null;
  return phoneGuidedWorkouts.find((workout) => {
    if (workout?.workout_prescription_id !== prescription.id) return false;
    if (delivery?.id && workout?.delivery_id && workout.delivery_id !== delivery.id) return false;
    return normalize(workout.guidance_mode) === 'phone_guided' || normalize(workout.guidance_mode) === 'read_only';
  }) || null;
};

export const phoneGuidedFallbackMessageKey = (delivery = null) => {
  const status = normalize(delivery?.status);
  if (status === 'blocked_no_verified_capability') {
    return 'connectedTraining.phoneGuidedDeliveryBlocked';
  }
  if (status === 'requires_user_confirmation') {
    return 'connectedTraining.phoneGuidedConfirmationRequired';
  }
  return 'connectedTraining.phoneGuidedFallbackAvailable';
};

export const phoneGuidedCompletionCopyKeys = () => [
  'connectedTraining.phoneGuidedManualCompletionTitle',
  'connectedTraining.phoneGuidedManualCompletionBody',
  'connectedTraining.phoneGuidedSyncedDataPreferred',
];
